import React,{useState,useEffect,}from 'react'
import { Table,Space,Modal,} from 'antd';
import {  useGoodsGuigeListQuery, } from '../../store/ReactWebSiteApi';
import GoodsSpecAdd from './GoodsSpecAdd';
import GoodsSpecEdit from './GoodsSpecEdit';
import GoodsSpecDel from './GoodsSpecDel';
function GoodsSpecList(props) {   
    const [openWhole,setOpenWhole] = useState(false);  
    const {data, isSuccess} = useGoodsGuigeListQuery({egg_e_id:localStorage.getItem('e_id'),egg_eg_id:props.egg_eg_id},{skip:!openWhole});
    const [list, setList] = useState();
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {egg_id:key,egg_name,} = item;
                    return item = {key,egg_name,}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.egg_ctime;
                    let bTimeString = b.egg_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess]) 
    const columns = [        
        {
            key: 'type',
            title: '规格名称',            
            dataIndex: 'egg_name',
        },
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },
       
        {
            key: 'action',
            title:'操作',
            render: (_, record) => {
                return <>
                    <Space>                            
                        <GoodsSpecEdit
                            egg_eg_id={props.egg_eg_id}
                            egg_id={record.key}
                        />
                        <GoodsSpecDel
                            egg_id={record.key}
                            egg_name={record.egg_name}
                        />
                    </Space>
                </>
            }
        },
    ]
   
 
    return (
        <>
            <a onClick={() => {setOpenWhole(true)}}>规格</a>
            <Modal
                open={openWhole}
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpenWhole(false);}}
                onOk={() => {}}
                footer={null}
                width={800}
                title={`${props.goodsName}的规格`}
            >
                <Space>
                    <GoodsSpecAdd
                        egg_eg_id={props.egg_eg_id}
                    />    
                </Space>
                <Table columns={columns} dataSource={list} pagination={{position:['none']}}></Table>
            </Modal>
           
        </>
    )
}

export default GoodsSpecList